import { useEffect, useState } from 'react';
import useFeatureToggle from '@guestyci/feature-toggle-fe/useFeatureToggle';
import initZowieSetup from './zowie-setup';
import ZendeskLauncher from './ZendeskLauncher';
import initZendeskWidget from './zendesk-setup';
import ZowieLauncher from './ZowieLauncher';

function ChatsWidgetContainer() {
  const [isZendesk, setIsZendesk] = useState(false);
  const [isZowie, setIsZowie] = useState(false);
  const [isFtLoading, isZowieEnabled] = useFeatureToggle('gfh_zowie_widget');

  useEffect(() => {
    if (isFtLoading) return;

    if (isZowieEnabled) {
      initZowieSetup().then(() => setIsZowie(true));
    } else {
      initZendeskWidget().then(() => setIsZendesk(true));
    }
  }, [isFtLoading, isZowieEnabled]);

  if (isZowie) {
    return <ZowieLauncher />;
  }

  if (isZendesk) {
    return <ZendeskLauncher />;
  }

  return null;
}

export default ChatsWidgetContainer;
